import { Button, Flex, Stack, Table, Text } from '@mantine/core'
import { openAddProviderLocationClinicModal } from '@v2/domains/membership/components/CreateProviderLocationClinicModal/CreateProviderLocationClinicModal.component'
import { openDeleteProviderModal } from '@v2/domains/membership/components/DeleteProviderModal.component'

import { Icons } from 'src/common/components'

import { ProviderDto } from '../../clinics.type'
import classes from './clinic-doctors-table.module.scss'

interface ProvidersTableProps {
  providers: ProviderDto[]
  clinicId: string
  clinicName: string
}

const ClinicDoctorsTable = ({
  providers,
  clinicName,
  clinicId,
}: ProvidersTableProps) => {
  return (
    <Table
      layout="fixed"
      classNames={{
        table: classes.table,
        thead: classes['table-head'],
        th: classes['table-th'],
        td: classes['table-td'],
      }}
      highlightOnHover={true}
      withTableBorder={true}
      withColumnBorders={true}
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th>
            <Flex justify="center" align="center" gap="xs">
              Provider Name
            </Flex>
          </Table.Th>
          <Table.Th>
            <Flex justify="center" align="center" gap="xs">
              Location
            </Flex>
          </Table.Th>
          <Table.Th>
            <Flex justify="center" align="center" gap="xs">
              Speciality
            </Flex>
          </Table.Th>
          <Table.Th></Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {providers.length > 0 ? (
          providers.map((provider, idx: number) => (
            <Table.Tr key={`${provider.membershipLocationId}-${idx}`}>
              <Table.Td>{provider.providerName}</Table.Td>
              <Table.Td>{provider.locationName}</Table.Td>
              <Table.Td>
                {provider?.metaData?.specialty ?? 'No Information'}
              </Table.Td>
              <Table.Td>
                <Flex justify="center" align="center" gap="md">
                  <Flex
                    onClick={() =>
                      openAddProviderLocationClinicModal(
                        clinicId,
                        clinicName,
                        provider,
                      )
                    }
                    c="blue"
                    justify="center"
                    align="center"
                    gap="xs"
                  >
                    <Icons.Edit />
                  </Flex>
                  <Flex
                    onClick={() => openDeleteProviderModal(provider.id ?? '')}
                    c="red"
                    justify="center"
                    align="center"
                    gap="xs"
                  >
                    <Icons.Trash />
                  </Flex>
                </Flex>
              </Table.Td>
            </Table.Tr>
          ))
        ) : (
          <Table.Td colSpan={4}>
            <Stack justify="center" align="center" gap="xs">
              <Text>No Proviers added yet</Text>
              <Button
                onClick={() =>
                  openAddProviderLocationClinicModal(clinicId, clinicName)
                }
                size="md"
                variant="subtle"
                leftSection={'+'}
              >
                Add a provider
              </Button>
            </Stack>
          </Table.Td>
        )}
      </Table.Tbody>
    </Table>
  )
}

export default ClinicDoctorsTable
